import { swapDates } from "components/dashboard/product-template-table/utils/timeUtils";
import { useState } from "react";
import { addToDate, truncateDate } from "utils/time-utils";
import { timeConfigValidation } from "utils/utils";

interface TimeContext {
  referenceTime?: string;
  from?: string;
  to?: string;
  config?: any;
}

const getTimeRange = (referenceTime: Date, config: any) => {
  const validatedConfig = config ? timeConfigValidation(config) : timeConfigValidation({});

  const startingDate = referenceTime ? new Date(referenceTime) : new Date();
  const tempDate = truncateDate(startingDate, config?.alignStartTo);

  const tempFrom = addToDate(
    tempDate,
    validatedConfig.startOffset,
    validatedConfig.startOffsetUnits
  );
  const tempTo = addToDate(tempFrom, validatedConfig.leadOffset, validatedConfig.leadUnits);

  const from = addToDate(tempFrom, validatedConfig.lagOffset * -1, validatedConfig.lagUnits);
  return swapDates(from, tempTo);
};

const useTimeState = (ctx: TimeContext) => {
  const defaultDate = (date: Date | string | undefined) => {
    return date ? new Date(date) : undefined;
  };
  const [from, setFromState] = useState<Date | undefined>(defaultDate(ctx.from));
  const [to, setToState] = useState<Date | undefined>(defaultDate(ctx.to));
  const [config, setConfig] = useState<any | undefined>(ctx?.config);
  const [ctxInit, setCtxInit] = useState<TimeContext | undefined>(ctx);
  const applyReferenceTime = (time?: Date | string, cfg?: any) => {
    if (ctxInit?.from && ctxInit.to) {
      return;
    }
    applyTimeOptions(time ? new Date(time) : new Date(), cfg ?? config);
    if (cfg) {
      setConfig(cfg);
    }
  };

  const applyTimeOptions = (refTime: Date, cfg: any) => {
    const { from: tFrom, to: tTo } = getTimeRange(refTime, cfg);
    if (
      new Date(tFrom).getTime() !== from?.getTime() ||
      new Date(tTo).getTime() !== to?.getTime()
    ) {
      setFromState(tFrom || from);
      setToState(tTo || to);
    }
  };

  const setFrom = (date: Date | string) => {
    setFromState(new Date(date));
  };

  const setTo = (date: Date | string) => {
    setToState(new Date(date));
  };

  return {
    applyReferneceTime: applyReferenceTime,
    from,
    setFrom,
    to,
    setTo,
  };
};

export default useTimeState;
